import { Injectable } from '@angular/core';
//import { AppComponent } from './../app.component';

@Injectable()
export class DateTimeManager {

    private dates: string;
    private dated: Date;

    constructor() {
        this.dates = undefined;
        this.dated = new Date();
    }

    convertNumberIntoDate(number, format: string){
        var d = new Date();
        d.setTime(number);
        this.setDate(d);
        if (format == "yyyymmdd"){
            return this.yyyymmdd("/");
        }
        return this.ddmmyyyy("/");
    }

    setDate(d: Date){
        this.dated = d;
    }

    setToday(){
        this.dated = new Date();
    }
    
    yyyymmdd(separator: string){
        var mm = this.dated.getMonth() + 1; // getMonth() is zero-based
        var dd = this.dated.getDate();
        
        this.dates = [this.dated.getFullYear(),
                (mm>9 ? '' : '0') + mm,
                  (dd>9 ? '' : '0') + dd
                 ].join(separator);
        return this.dates;
    }
    
    yyyyddmm(separator: string){
        var mm = this.dated.getMonth() + 1; // getMonth() is zero-based
        var dd = this.dated.getDate();
        
        this.dates = [this.dated.getFullYear(),
              (dd>9 ? '' : '0') + dd,
                (mm>9 ? '' : '0') + mm
                 ].join(separator);
        return this.dates;
    }
    
    ddmmyyyy(separator: string){
        var mm = this.dated.getMonth() + 1; // getMonth() is zero-based
        var dd = this.dated.getDate();
        
        this.dates = [(dd>9 ? '' : '0') + dd,
                  (mm>9 ? '' : '0') + mm,
                  this.dated.getFullYear()
                 ].join(separator);
        return this.dates;
    }   
    
    mmddyyyy(separator: string){
        var mm = this.dated.getMonth() + 1; // getMonth() is zero-based
        var dd = this.dated.getDate();
        
        this.dates = [(mm>9 ? '' : '0') + mm,
                  (dd>9 ? '' : '0') + dd,
                  this.dated.getFullYear()
                 ].join(separator);
        return this.dates;
    }

    /**
     * Funzione che restituire una data modificatoa
     * 
     * @param date data di partenza
     * @param number numero di giorni o mesi o anni da aggiungere o sottrarre
     * @param item d -> giorni, m -> mesi, y -> anni
     */
    dateCalculation(date, number, item){
        var dat = new Date(date.valueOf());
        switch(item){
            case "d":
                dat.setDate(dat.getDate() + parseInt(number));
                break;
            case "m":
                dat.setMonth(dat.getMonth() + parseInt(number));
                break;
            case "y":
                dat.setFullYear(dat.getFullYear() + parseInt(number));
                break;
        }
        this.dated = dat;
    }
    
}



// WEBPACK FOOTER //
// ./src/app/manager/datetime.manager.ts